import type { ReactNode } from 'react'

function NumberBadge({ value }: { value: number }) {
  return (
    <span className='inline-flex h-6 w-6 items-center justify-center rounded-md bg-primary text-xs font-medium text-white'>
      {value}
    </span>
  )
}

export function SectionCard({
  index,
  title,
  children,
  flat = false,
}: {
  index: number
  title: string
  children: ReactNode
  flat?: boolean
}) {
  if (flat) {
    return <div className='space-y-4'>{children}</div>
  }

  return (
    <section className='rounded-2xl border border-[#e7e9ef] bg-background shadow-[0_1px_3px_rgba(23,26,32,0.04)]'>
      <div className='flex items-center gap-2 px-4 py-4'>
        <NumberBadge value={index} />
        <h3 className='font-heading text-sm font-semibold leading-[1.2] tracking-normal text-foreground'>
          {title}
        </h3>
      </div>
      <div className='space-y-4 px-4 pb-4'>{children}</div>
    </section>
  )
}
